import React from "react";
import { BillingCard } from "./BillingCard";
import { BillingUIProvider } from "./BillingUIContext";

export function BillingPage({ history }) {
  const billingUIEvents = {
    newBillingIndividuButtonClick: () => {
      history.push("/billing/individual/new");
    },
    newBillingOrganizationButtonClick: () => {
      history.push("/billing/organization/new");
    },
    openEditBillingIndividualPage: (id) => {
      history.push(`/billing/individual/${id}/edit`);
    },
    openEditBillingOrganizationPage: (id) => {
      history.push(`/billing/organization/${id}/edit`);
    },
    openDeleteBillingPage: (id) => {
      history.push(`/billing/${id}/delete`);
    },
  };

  return (
    <BillingUIProvider billingUIEvents={billingUIEvents}>
      <BillingCard />
    </BillingUIProvider>
  );
}
